import PropTypes from "prop-types";
import {
  Box,
  Container,
  Stack,
  Typography,
} from "@mui/material";
import Loader from "../Loader";

function EntityListPage({
  loading,
  title,
  headerAction,
  toolbar,
  mountedSearch,
  search,
  searchAside,
  table,
}) {
  return (
    <>
      {mountedSearch}
      {loading && <Loader />}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: 2,
        }}
      >
        <Container maxWidth="xl">
          <Stack spacing={3}>
            <Stack direction="row" justifyContent="space-between" spacing={4}>
              <Stack spacing={1}>
                <Typography variant="h4">{title}</Typography>
              </Stack>
              {headerAction}
            </Stack>
            {toolbar ? (
              <Stack alignItems="center" direction="row" spacing={1}>
                {toolbar}
              </Stack>
            ) : null}
            {(search || searchAside) && (
              <Stack
                alignItems="center"
                direction="row"
                justifyContent="space-between"
                spacing={2}
              >
                <Box sx={{ flexGrow: 1, maxWidth: 500 }}>{search}</Box>
                {searchAside}
              </Stack>
            )}
            {table}
          </Stack>
        </Container>
      </Box>
    </>
  );
}

EntityListPage.propTypes = {
  headerAction: PropTypes.node,
  loading: PropTypes.bool,
  mountedSearch: PropTypes.node,
  search: PropTypes.node,
  searchAside: PropTypes.node,
  table: PropTypes.node,
  title: PropTypes.string.isRequired,
  toolbar: PropTypes.node,
};

EntityListPage.defaultProps = {
  headerAction: null,
  loading: false,
  mountedSearch: null,
  search: null,
  searchAside: null,
  table: null,
  toolbar: null,
};

export default EntityListPage;
